/* WRLD TAGS  ·  product card image carousel on touch screens
   Loaded on every page from layout/theme.liquid (defer), right after theme.js.
   WHY: the Concept theme only runs the card image carousel (<secondary-media>,
   Flickity, dots) on desktop, driven by mouse position, and hides it under
   768px. Jaime (Sept 10, 2026) wants the dots on mobile too. wt-collection.css
   un-hides the carousel on mobile; this script makes sure it initialises and
   turns on swiping (draggable) on touch devices. Desktop keeps the theme's
   hover behaviour untouched.
   RULES: never call init() twice on the same element (guard on children).
   Two triggers on purpose: IntersectionObserver, plus a scroll/touch fallback
   that checks the viewport by hand, because the observer does not fire in
   every embedded browser. */
(function () {
  'use strict';
  var TOUCH = window.matchMedia('(pointer: coarse)').matches;
  var pending = [];

  function ready(sm) {
    try { if (sm.children.length === 0 && typeof sm.init === 'function') sm.init(); } catch (err) {}
    if (TOUCH && sm.carousel && !sm.__wtDrag) {
      sm.__wtDrag = true;
      sm.carousel.options.draggable = true;
      if (sm.carousel.updateDraggable) sm.carousel.updateDraggable();
    }
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -200 && r.top < window.innerHeight + 200 && r.width > 0;
  }

  function arm(sm) {
    if (sm.__wt) return;
    sm.__wt = true;
    pending.push(sm);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          setTimeout(function () { ready(sm); }, 150);
        });
      }, { rootMargin: '200px 0px' });
      io.observe(sm);
    }
  }

  function sweep() {
    pending = pending.filter(function (sm) {
      if (!document.contains(sm)) return false;
      if (sm.children.length > 0 && (!TOUCH || sm.__wtDrag)) return false;
      if (inViewport(sm)) ready(sm);
      return sm.children.length === 0 || (TOUCH && !sm.__wtDrag);
    });
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('.product-card secondary-media') : []).forEach(arm);
  }

  var t = null;
  function throttled() { if (t) return; t = setTimeout(function () { t = null; sweep(); }, 200); }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
      throttled();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', throttled, { passive: true });
    window.addEventListener('touchstart', throttled, { passive: true });
    window.addEventListener('resize', throttled);
    setTimeout(sweep, 600);
    setTimeout(sweep, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
